import InputField from '../../inputs/inputField'

export default function CountersignForm({
	formData,
	setFormData,
	requiredFields,
}: {
	formData: any
	setFormData: (data: any) => void
	requiredFields: any[]
}) {
	const handleDataChange = (name: string, value: string) => {
		let newData = { ...formData }
		newData[name] = value
		setFormData(newData)
	}

	return (
		<div className="flex w-full flex-col gap-y-2">
			<InputField
				name="description"
				lines={4}
				placeholder="Add context to this offchain history signature"
				containerWidth="w-full"
				additionalClasses="h-32"
				value={formData.description}
				onChange={e => {
					handleDataChange('description', e.target.value)
				}}
				isError={requiredFields.find(
					requiredField => requiredField.slug == 'description',
				)}
			/>
		</div>
	)
}
